export default "./dist/stdassets/images/icons/query.png";